import API from '../api'

export const getTransactionHistory = (params) => (
  API.get(`/api/v1/deposit/transaction?method=Crypto&${params}`)
)

export const getTransactionHistoryWire = (params) => (
  API.get(`/api/v1/deposit/transaction?method=Wire&${params}`)
)
